<div class="pt-4" *ngIf="serverError !== null">
  <div class="alert alert-danger">
    Server Error: {{ serverError }}
  </div>
</div>

<div class="pt-4 pl-md-4 mb-6" *ngIf="serverError === null">

  <div class="clearfix mb-2">
    <button class="btn btn-sm btn-outline-primary float-right mb-2 ml-2"
            style="height: 33px"
            role="button"
            [disabled]="loadingSummaries"
            [class.disabled]="loadingSummaries"
            (click)="openExportListModal()">
      Export List
    </button>
    <button class="btn btn-sm btn-outline-primary float-left mb-2 mr-2"
            style="height: 33px"
            role="button"
            [disabled]="loadingFiltersModalRequirements()"
            [class.disabled]="loadingFiltersModalRequirements()"
            (click)="openEditFiltersModal()">
      {{ loadingFiltersModalRequirements() ? 'Loading...' : 'Edit Filters' }}
    </button>
    <span *ngFor="let activeFilter of getActiveFilters()"
          class="filter-item mb-2 mr-2 cursor-pointer"
          (click)="openEditFiltersModal()">{{ activeFilter }}</span>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table table-hover" *ngIf="!loadingSummaries && summaries && (summaries.length > 0)">
      <thead>
      <tr>
        <th scope="col">Event</th>
        <th scope="col">Date</th>
        <th scope="col">Time</th>
        <th scope="col" *ngIf="showLocationColumn()">Location</th>
        <th scope="col">Event Type</th>
        <th scope="col">Waiting</th>
        <th scope="col">Pending</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody style="line-height: 16px;">
      <tr *ngFor="let summary of summaries"
          class="cursor-pointer"
          [routerLink]="getEventWaitlistSummaryRouterPath(summary)"
          fragment="waitlist">
        <td>{{ getEventDisplay(summary) }}</td>
        <td class="text-nowrap">{{ dateStringFromISO8601(summary.first_start_datetime, summary.time_zone) }}</td>
        <td class="text-nowrap">{{ timeStringFromISO8601(summary.first_start_datetime, summary.time_zone) }}</td>
        <td *ngIf="showLocationColumn()">{{ summary.location_name }}</td>
        <td>{{ summary.event_type_name }}</td>
        <td>{{ summary.waiting_count }}</td>
        <td>{{ summary.pending_count }}</td>
        <td class="table-button-cell text-right">
          <a [routerLink]="getEventWaitlistSummaryRouterPath(summary)"
             fragment="waitlist"
             (click)="$event.stopPropagation()"
             class="btn btn-outline-primary btn-sm bg-white-not-important">
            Open
          </a>
        </td>
      </tr>
      </tbody>
    </table>

    <table class="table" *ngIf="loadingSummaries || !(summaries && (summaries.length > 0))">
      <thead>
      <tr>
        <th scope="col">Event</th>
        <th scope="col">Date</th>
        <th scope="col">Time</th>
        <th scope="col" *ngIf="showLocationColumn()">Location</th>
        <th scope="col">Event Type</th>
        <th scope="col">Waiting</th>
        <th scope="col">Pending</th>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td colspan="99">
          {{ loadingSummaries ? 'Loading...' : 'No events' }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="eventWaitlistsPageSize" (change)="handlePageSizeChange()">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

</div>
